export default __webpack_public_path__ + "047b905e1a9baf984bcd3c73ca6c79ac.png";